import { Link } from 'react-router-dom';
import { ServiceDefinition } from '@/types/routes';
import * as S from './CommandCenter.styles';

type CommandCenterProps = {
  greeting: string;
  dateString: string;
  todayFact: string;
  services: ServiceDefinition[];
};

const CommandCenter = ({
  greeting,
  dateString,
  todayFact,
  services,
}: CommandCenterProps): JSX.Element => {
  return (
    <div data-testid="command-center">
      <S.GreetingRow>
        <S.GreetingBlock>
          <S.GreetingText>{greeting}</S.GreetingText>
          <S.DateText>{dateString}</S.DateText>
        </S.GreetingBlock>
        <S.FactCard>
          <S.FactLabel>This Day in Tech History</S.FactLabel>
          <S.FactText>{todayFact}</S.FactText>
        </S.FactCard>
      </S.GreetingRow>

      <S.SectionLabel>Your Services</S.SectionLabel>
      <S.ServiceGrid>
        {services.map((service) => {
          const Icon = service.icon;
          return (
            <S.ServiceCard
              key={service.id}
              as={Link}
              to={service.landingPath ?? service.basePath}
              $accentColor={service.color}
            >
              <S.ServiceIconWrapper $color={service.color}>
                <Icon sx={{ fontSize: 22 }} />
              </S.ServiceIconWrapper>
              <S.ServiceName>{service.name}</S.ServiceName>
              <S.ServiceDescription>{service.description}</S.ServiceDescription>
            </S.ServiceCard>
          );
        })}
      </S.ServiceGrid>
    </div>
  );
};

export default CommandCenter;
